/**
 * Single source of truth for the boxes in the conversation header.
 *
 * The header mixes controls owned by six different components (actions popover,
 * SLA, reminders, call, resolve/snooze/pending, flows, lifecycle). Each of them
 * used to carry its own copy of the styling, which drifted apart: box sizes of
 * 24, 28, 32 and 40px, two different border treatments, and an extra ring on
 * some of them. They all import from here now.
 *
 * Two traps are encoded in these strings, both proven on the running app:
 *
 * 1. `!border` - the shared Button component sets `border-0` in its own base
 *    classes and Tailwind emits `.border-0` after `.border`, so a plain border
 *    utility loses the tie.
 * 2. `!border-solid` - the legacy base stylesheet applies `border-none` to every
 *    <button> on the page, and a border of style none computes to zero width no
 *    matter what the width says. Setting the width alone leaves the frame
 *    invisible; that is what the `ring-1` on the old buttons was compensating
 *    for.
 *
 * Sizes are forced too, because these components each pass their own size prop
 * (xs/sm/md) and the box must not depend on it.
 */

/** Frame, surface and hover shared by every control in the header row. */
export const HEADER_CONTROL_BASE_CLASS =
  '!rounded-lg !border !border-solid !border-n-slate-7 bg-n-surface-1 shadow-sm transition-colors duration-150 hover:!border-n-slate-9 hover:!bg-n-alpha-2 dark:!border-n-slate-6 dark:hover:!border-n-slate-8';

/** Square icon-only buttons. */
export const HEADER_ACTION_BUTTON_CLASS = `!size-8 ${HEADER_CONTROL_BASE_CLASS}`;

/** Controls that carry text and size to their content, at the same height. */
export const HEADER_TEXT_CONTROL_CLASS = `!h-8 ${HEADER_CONTROL_BASE_CLASS}`;

export default HEADER_ACTION_BUTTON_CLASS;
